<h1 mat-dialog-title>Errore</h1>
<div mat-dialog-content>

  <p *ngIf="message; else genericMessage">{{message}}</p>

</div>

<ng-template #genericMessage>
  <p>{{'messages.errors.generic' | translate}}</p>
</ng-template>
